export default __webpack_public_path__ + "static/media/dolly2.10cc05ce.jpg";